import { createSlice } from '@reduxjs/toolkit'

export const companyDetailSlice = createSlice({
    name: 'companyDetail',
    initialState: {
        companyDetails: []
    },
    reducers: {
        companyUpdate: (state, action) => {
            state.companyDetails = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const { companyUpdate } = companyDetailSlice.actions

export default companyDetailSlice.reducer